import { FilterOption } from '@commerce-payment-webcomponents/sdk';
import { createContext } from 'react';

const FilterOptionContext = createContext<FilterOption | undefined>(undefined);

export default FilterOptionContext;
